<div style="height: calc(100%); width: 100%;" class="ui-dark-background" data-cy="draw-magnify-container">
  <mat-card appearance="outlined" style="width: 100%; height: calc(100%); display: flex; flex-direction: column;" data-cy="draw-magnify-card">
    <span class="configuration-section-title" data-cy="draw-magnify-title">Magnification Tools</span>
    <app-tdo-configuration-action-bar newHidden="true" (saveClick)="onSave($event)" data-cy="draw-magnify-action-bar"></app-tdo-configuration-action-bar>
    <mat-card-title data-cy="draw-magnify-glass-title">Magnify Glass Object</mat-card-title>
    <mat-card-subtitle data-cy="draw-magnify-subtitle">Magnifying glass default properties.</mat-card-subtitle>
    <br/>

    <table style="width: 618px; border-spacing: 0 8px;" data-cy="draw-magnify-table">
      <!-- Shape and Dimensions Row -->
      <tr data-cy="draw-magnify-dimensions-row">
        <td style="width: 200px; height: 50px;" data-cy="draw-magnify-shape-field">
          <tdo-dropdown-v2 *ngIf="drawMagnificationDefaults" widthString="200px" placeholder="Shape" placeholderPosition="above" 
            [datasource]="leadToolsHelper.enumShapes" displayProperty="name" [value]="leadToolsHelper.getShape(this.drawMagnificationDefaults.shape)"
            (selectionChange)="onShapeChange($event); dropdownChange($event);" data-cy="draw-magnify-shape-dropdown"></tdo-dropdown-v2>
        </td>
        <td style="width: 6px;"></td>
        <td style="width: 100px; text-align: right;" data-cy="draw-magnify-width-label">
          <label class="col-form-label">Width</label>
        </td>
        <td style="width: 100px;" data-cy="draw-magnify-width-input">
          <input type="number" min="1" class="form-control" style="width: 100%; min-width: 100px;" [value]="width" (input)="width = $event.target.value; configurationService.setDirty();">
        </td>
        <td style="width: 6px;"></td>
        <td style="width: 100px; text-align: right;" data-cy="draw-magnify-height-label">
          <label class="col-form-label">Height</label>
        </td>
        <td style="width: 100px;" data-cy="draw-magnify-height-input">
          <input type="number" min="1" class="form-control" style="width: 100%; min-width: 100px;" [value]="height" (input)="height = $event.target.value; configurationService.setDirty();">
        </td>
      </tr>

      <!-- Border Settings Row -->
      <tr data-cy="draw-magnify-border-row">
        <td style="width: 200px; height: 50px;" data-cy="draw-magnify-border-width-field">
          <tdo-dropdown-v2 *ngIf="drawMagnificationDefaults" widthString="200px" placeholder="Border Width" placeholderPosition="above" 
            [datasource]="leadToolsHelper.Widths" displayProperty="value" [value]="leadToolsHelper.getWidth(this.drawMagnificationDefaults.borderWidth)"
            (selectionChange)="onBorderWidth($event); dropdownChange($event);" data-cy="draw-magnify-border-width-dropdown"></tdo-dropdown-v2>
        </td>
        <td style="width: 6px;"></td>
        <td style="width: 100px; text-align: right;" data-cy="draw-magnify-border-color-label">
          <label class="col-form-label">Border Color</label>
        </td>
        <td colspan="4" data-cy="draw-magnify-border-color-field">
          <app-tdo-color-picker style="width: 100%;" placeholder="Border Color" [color]="borderColor"
            (colorChange)="onBorderColorChange($event);configurationService.setDirty();" data-cy="draw-magnify-border-color-picker"></app-tdo-color-picker>
        </td>
      </tr>

      <!-- Line Caps Row -->
      <tr data-cy="draw-magnify-line-caps-row">
        <td style="width: 200px; height: 50px;" data-cy="draw-magnify-line-start-field">
          <tdo-dropdown-v2 *ngIf="drawMagnificationDefaults" widthString="200px" placeholder="Line Start Cap" placeholderPosition="above" 
            [datasource]="leadToolsHelper.enumCaps" displayProperty="name" [value]="leadToolsHelper.getLineCap(this.drawMagnificationDefaults.lineStartCap)"
            (selectionChange)="onLineStartCapChange($event); dropdownChange($event);" data-cy="draw-magnify-line-start-dropdown"></tdo-dropdown-v2>
        </td>
        <td colspan="6"></td>
      </tr>
      <tr data-cy="draw-magnify-line-end-row">
        <td style="width: 200px; height: 50px;" data-cy="draw-magnify-line-end-field">
          <tdo-dropdown-v2 *ngIf="drawMagnificationDefaults" widthString="200px" placeholder="Line End Cap" placeholderPosition="above" 
            [datasource]="leadToolsHelper.enumCaps" displayProperty="name" [value]="leadToolsHelper.getLineCap(this.drawMagnificationDefaults.lineEndCap)"
            (selectionChange)="onLineEndCapChange($event); dropdownChange($event);" data-cy="draw-magnify-line-end-dropdown"></tdo-dropdown-v2>
        </td>
        <td colspan="6"></td>
      </tr>

      <!-- Crosshairs Checkbox Row -->
      <tr data-cy="draw-magnify-crosshairs-checkbox-row">
        <td colspan="7">
          <mat-checkbox [checked]="hasCrosshairs" (change)="hasCrosshairs = $event.checked; configurationService.setDirty();" 
            data-cy="draw-magnify-crosshairs-checkbox">Has Crosshairs</mat-checkbox>
        </td>
      </tr>

      <!-- Crosshairs Settings Row -->
      <tr data-cy="draw-magnify-crosshairs-row" *ngIf="hasCrosshairs">
        <td style="width: 200px; height: 50px;" data-cy="draw-magnify-crosshairs-width-field">
          <tdo-dropdown-v2 *ngIf="drawMagnificationDefaults" widthString="200px" placeholder="Crosshair Width" placeholderPosition="above" 
            [datasource]="leadToolsHelper.Widths" displayProperty="value" [value]="leadToolsHelper.getWidth(this.drawMagnificationDefaults.crosshairWidth)"
            (selectionChange)="onCrosshairWidthChange($event); dropdownChange($event);" data-cy="draw-magnify-crosshairs-width-dropdown"></tdo-dropdown-v2>
        </td>
        <td colspan="6"></td>
      </tr>

      <!-- Crosshairs Color Row -->
      <tr data-cy="draw-magnify-crosshairs-color-row" *ngIf="hasCrosshairs">
        <td colspan="7" data-cy="draw-magnify-crosshairs-color-field">
          <app-tdo-color-picker style="width: 100%;" label="Crosshairs Color" placeholder="Border Color" [color]="crosshairColor" 
            (colorChange)="onCrosshairColorChange($event); configurationService.setDirty();" data-cy="draw-magnify-crosshairs-color-picker"></app-tdo-color-picker>
        </td>
      </tr>

      <!-- Scale Factor Row -->
      <tr data-cy="draw-magnify-scale-row">
        <td style="width: 200px; height: 50px;" data-cy="draw-magnify-scale-field">
          <mat-label data-cy="draw-magnify-scale-label">Scale Factor</mat-label>
          <input type="number" min="1" class="form-control" style="width: 100%;" [value]="scaleFactor" 
            (input)="scaleFactor = $event.target.value; configurationService.setDirty();" data-cy="draw-magnify-scale-input">
        </td>
        <td colspan="6"></td>
      </tr>
    </table>
  </mat-card>
</div>

